module.exports = __webpack_public_path__ + "static/media/america.39e7d70e.png";